import { Box, Center, Flex, Icon, Text } from "@chakra-ui/react";
import { TbAlertTriangle } from "react-icons/tb";
import { GETLicensePayload } from "../utils";
import { DolarIcon3 } from "components/vectors/dolar-icon";
import { CheckCircleIcon } from "@chakra-ui/icons";
import { useApplicationContext } from "contexts/ApplicationContext";
import { MASTER_PRICE, VO_PRICE } from "./license-and-billing";
import { handleSaveUserLicence } from "./modals/utils";
import { ButtonWithLoading } from "components/mailing-components/mailing-table/icon-button-with-loading";

interface PaymentBannerProps {
  licenseData: Partial<GETLicensePayload>;
  onUpdateLicenses: (data?: GETLicensePayload | undefined) => void;
}
export function PaymentBanner({
  licenseData,
  onUpdateLicenses
}: PaymentBannerProps) {
  const { user } = useApplicationContext();

  const customerId = user.userData.customerId!;

  if (!licenseData.expired || !licenseData.userCanRenew) return null;

  return (
    <Flex
      bg="red.50"
      border="1px"
      borderColor="red.100"
      borderRadius="lg"
      px="24px"
      py="8px"
      mb={4}
      direction={{ base: "column", sm: "row" }}
      align="center"
      justify="space-between"
      gap={4}
    >
      <Flex align="center" gap={3}>
        <Center
          p={2}
          bg="white"
          borderRadius="full"
          boxShadow="sm"
          w="40px"
          minW="40px"
          h="40px"
        >
          <Icon as={TbAlertTriangle} w={5} h={5} color="red.600" />
        </Center>
        <Flex alignItems="center" fontSize="sm">
          <Text
            fontWeight="semibold"
            fontSize="12px"
            color="red.700"
            display="inline"
          >
            Pagamento pendente
          </Text>

          <Box
            h="16px"
            borderLeft="1px solid var(--chakra-colors-red-300)"
            display="inline"
            mx="10px"
          />

          <Text color="red.800" display="inline"></Text>

          <Flex flexDir="column" fontSize="12px" color="red.700">
            <Flex alignItems="center" gap={1}>
              <Icon as={DolarIcon3} w={3} h={3} />
              <Text>
                Valor a pagar:{" "}
                <Text as="strong">
                  R${" "}
                  {Number(
                    licenseData.pendingQtyLicenseMaster! * MASTER_PRICE +
                      licenseData.pendingQtyLicenseVendedorOrOperacional! *
                        VO_PRICE
                  )
                    .toFixed(2)
                    .replace(".", ",")}
                </Text>
              </Text>
            </Flex>
          </Flex>
        </Flex>
      </Flex>

      <ButtonWithLoading
        variant="danger"
        fontSize="12px"
        leftIcon={<CheckCircleIcon width="14px" height="14px" />}
        onClick={() =>
          handleSaveUserLicence({
            customerId,
            onUpdateLicenses,
            targetMaster: licenseData.pendingQtyLicenseMaster ?? 0,
            targetVO: licenseData.pendingQtyLicenseVendedorOrOperacional ?? 0,
            onSuccess() {
              window.location.reload();
            }
          })
        }
      >
        Pagar agora
      </ButtonWithLoading>
    </Flex>
  );
}
